// @core/api/endpoints/document/build_template_from_clauses.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BuildTemplateFromClausesRequest,
  DocumentTemplateResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Build template from clauses
 * Creates a draft DocumentTemplate by concatenating the bodies of the referenced clauses in order. Resulting template is in DRAFT / inactive state until the lawyer reviews and activates it.
 */
export async function BuildTemplateFromClauses(
  data: BuildTemplateFromClausesRequest,
  options?: RequestOptions
): Promise<DocumentTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-templates/build-from-clauses`;
  const requestOptions = options;
  return client.post<DocumentTemplateResponse>(requestPath, data, requestOptions);
}
